export enum ClientType {
    NEW = 1,
    EXISTING = 2,
}
